<template>
    <div class="div-bg">
        <div style="text-align: center;font-size: 100px;color: red;position: relative;" ref="mainDiv"
             :style="{top:mainTop+'px'}">404
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdFooter from './public/Footer'

export default {
    name: 'Error',
    components: {
        HdFooter
    },
    data () {
        return {
            mainTop: 0
        }
    },
    methods: {
        setPosition () {
            let h = this.$refs.mainDiv.offsetHeight
            this.mainTop = this.getClientTop(h)
            console.log(' this.mainTop:', this.mainTop)
        }
    },
    mounted () {
        this.$nextTick(function () {
            this.setPosition()
        })
    }
}
</script>

<style scoped>
.div-bg {
    background-image: url(../assets/images/login_bg.png);
    border: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Error.vue